import axios from "axios";

import store from "../../reduxStore";

export async function getReports(filter) {
  const customerNumber = store.getState().app.currentCustomer.Number;
  const url = `Reports/Report?$filter=CustomerNumber eq ${customerNumber} and ${filter}`;
  try {
    const { data } = await axios({
      method: "get",
      url,
      responseType: "blob",
    });

    return data;
  } catch (error) {
    return error;
  }
}

export async function getAreaalReport(filter) {
  const url = `Reports/Report?$filter=${filter}`;
  try {
    const { data } = await axios({
      method: "get",
      url,
      responseType: "blob",
    });

    return data;
  } catch (error) {
    return error;
  }
}
